import RareBoxLogo from "Logos/RareBoxLogo";
import axios from "axios";
import { studioAttrGrpAttrAssocObj } from "components/PimDashboard/DashboardComponents/Studio/StudioAttributes/data";

import { CustomLinearProgress } from "components/ReusableComponents/CustomLinearProgress/CustomLinearProgress";
import React, { createContext, useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

const StudioDashboardContext = createContext();

const StudioDashboardProvider = () => {
	const [attrGroupsWithAttr, setAttrGroupsWithAttr] = useState();
	const [allAttributes, setAllAttributes] = useState();
	const [allAttributesObj, setAllAttributesObj] = useState();
	const [selectedShoot, setSelectedShoot] = useState();
	const [selectedModalProfile, setSelectedModalProfile] = useState();

	useEffect(() => {
		const fetch = async () => {
			try {
				await axios.get(`/api/studio_attr_master/attr_grp_with_attrs`).then((res) => {
					let obj = res.data?.result?.length ? {} : null;
					let attrArr = [];
					let attrArrObj = {};
					res.data?.result?.forEach((row) => {
						obj[row.group_id] = row;
						row[studioAttrGrpAttrAssocObj].forEach((attr) => {
							attrArr.push(attr);
							attrArrObj = { ...attrArrObj, [attr?.key]: attr };
						});
					});
					console.log(obj, attrArr, "attrArrattrArrattrArr");

					if (obj) {
						setAttrGroupsWithAttr(obj);
						setAllAttributes(attrArr);
						setAllAttributesObj(attrArrObj);
					}
				});
			} catch (error) {
				console.log(error);
			}
		};
		fetch();
	}, []);

	return (
		<StudioDashboardContext.Provider
			value={{
				attrGroupsWithAttr,
				setAttrGroupsWithAttr,
				allAttributes,
				setAllAttributes,
				allAttributesObj,
				setAllAttributesObj,
				setSelectedShoot,
				selectedShoot,
				selectedModalProfile,
				setSelectedModalProfile,
			}}>
			{attrGroupsWithAttr ? (
				<Outlet />
			) : (
				<div
					style={{
						width: "160px",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%,-50%)",
					}}>
					<RareBoxLogo width="100%" />
					<CustomLinearProgress height="4px" />
				</div>
			)}
		</StudioDashboardContext.Provider>
	);
};

export const StudioDashboardState = () => {
	return useContext(StudioDashboardContext);
};

export default StudioDashboardProvider;
